import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { ReactNode } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { LocationProvider } from './LocationProvider';
import { queryClient } from './queryClient';
import { AuthProvider } from './AuthProvider';

export const AppProviders = ({ children }: { children: ReactNode }) => (
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <LocationProvider>
        <ThemeProvider>
          <HelmetProvider>
            <BrowserRouter
              future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
            >
              {children}
            </BrowserRouter>
          </HelmetProvider>
        </ThemeProvider>
      </LocationProvider>
    </QueryClientProvider>
  </AuthProvider>
);
